import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { formatNumberWithCommas } from "@/utils";

interface RankingItemProps {
  ranking: number;
  thumbnail: string;
  name: string;
  points: number;
}

const RankingColors = {
  1: "#FFD700",
  2: "#C0C0C0",
  3: "#CD7F32",
};

const RankingItem = ({ ranking, thumbnail, name, points }: RankingItemProps) => {
  return (
    <div
      className="grid grid-cols-[1rem_auto_1fr_auto] gap-2 items-center p-2"
      style={{
        backgroundColor: `${RankingColors[ranking as keyof typeof RankingColors]}50`,
      }}
    >
      <div className="text-xl font-bold text-center">{ranking}</div>
      <div>
        <Avatar>
          <AvatarImage src={thumbnail} />
          <AvatarFallback>{name.slice(0, 2)}</AvatarFallback>
        </Avatar>
      </div>
      <div>{name}</div>
      <div>{formatNumberWithCommas(points.toString())}pt</div>
    </div>
  );
};

interface User {
  id: string;
  name: string;
  thumbnail: string;
  points: number;
}

interface PublicRankingProps {
  users: User[];
}

export const PublicRanking = ({ users }: PublicRankingProps) => {
  return (
    <div className="py-5">
      <div className="text-xl font-bold mb-2">TOP3</div>
      <div className="grid">
        {users.map((user, index) => (
          <RankingItem
            key={user.id}
            ranking={index + 1}
            thumbnail={user.thumbnail}
            name={user.name}
            points={user.points}
          />
        ))}
      </div>
    </div>
  );
};
